<template>
	<div>
		<case-form :schema="schema" class="mt6" />

		<div class="fs4 fw7 lh125 mt6 mb2">Purpose of your diving activities</div>
		<case-form :schema="schemaPurpose" />

		<div class="fs4 fw7 lh125 mt6 mb2">Where do you dive?</div>
		<case-form :schema="schemaLocation" />

		<div class="fs4 fw7 lh125 mt6 mb2">
			Type of diving activities (check all that apply)
		</div>
		<case-form :schema="schemaType" />

		<div class="fs4 fw7 lh125 mt6 mb2">
			Please provide details of your diving
		</div>
		<j-accordion
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="fs4 fw7 lh125">Less than 50 feet (< 15.5 m)</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaLessThan50ft" :isBoxed="false" />
			</div>
		</j-accordion>

		<j-accordion
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="fs4 fw7 lh125">50 - 75 feet (15.5 m – 23 m)</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schema50to75ft" :isBoxed="false" />
			</div>
		</j-accordion>

		<j-accordion
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="fs4 fw7 lh125">76 - 100 feet (23 m – 30.5 m)</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schema76to100ft" :isBoxed="false" />
			</div>
		</j-accordion>

		<j-accordion
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="fs4 fw7 lh125">101 - 120 feet (30.5 m – 36.5 m)</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schema101to120ft" :isBoxed="false" />
			</div>
		</j-accordion>

		<j-accordion
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="fs4 fw7 lh125">Over 120 feet (>36.5m)</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaOver120ft" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schema() {
			return [
				{
					label: "Are you a certified diver?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isCertifiedDiver`,
					props: {
						suggest: {
							typeIncludes: `isCertifiedDiver`
						},
						createOptions: {
							type: `isCertifiedDiver`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Level of certification",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diverCertLevel`,
					props: {
						suggest: {
							typeIncludes: `diverCertLevel`
						},
						createOptions: {
							type: `diverCertLevel`,
							dataType: "string"
						}
					}
				},
				{
					label: "Are you a member of an organized diving club?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isMemberOfDivingClub`,
					props: {
						suggest: {
							typeIncludes: `isMemberOfDivingClub`
						},
						createOptions: {
							type: `isMemberOfDivingClub`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, provide details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0memberOfDivingClubDetails`,
					props: {
						suggest: {
							typeIncludes: `memberOfDivingClubDetails`
						},
						createOptions: {
							type: `memberOfDivingClubDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: "Do you dive alone?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDiveAlone`,
					props: {
						suggest: {
							typeIncludes: `isDiveAlone`
						},
						createOptions: {
							type: `isDiveAlone`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If yes, provide details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diveAloneDetails`,
					props: {
						suggest: {
							typeIncludes: `diveAloneDetails`
						},
						createOptions: {
							type: `diveAloneDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaPurpose() {
			return [
				{
					label: "Recreation only",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingForRecreation`,
					props: {
						suggest: {
							typeIncludes: `isDivingForRecreation`
						},
						createOptions: {
							type: `isDivingForRecreation`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Commercial",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingForCommercial`,
					props: {
						suggest: {
							typeIncludes: `isDivingForCommercial`
						},
						createOptions: {
							type: `isDivingForCommercial`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaType() {
			return [
				{
					label: "Instruction",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeInstruction`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeInstruction`
						},
						createOptions: {
							type: `isDivingTypeInstruction`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Construction",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeConstruction`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeConstruction`
						},
						createOptions: {
							type: `isDivingTypeConstruction`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Salvage",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeSalvage`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeSalvage`
						},
						createOptions: {
							type: `isDivingTypeSalvage`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Wreck Diving",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeWreckDiving`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeWreckDiving`
						},
						createOptions: {
							type: `isDivingTypeWreckDiving`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Ice Diving",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeIceDiving`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeIceDiving`
						},
						createOptions: {
							type: `isDivingTypeIceDiving`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Search Work",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeSearchWork`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeSearchWork`
						},
						createOptions: {
							type: `isDivingTypeSearchWork`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Cave diving",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeCaveDiving`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeCaveDiving`
						},
						createOptions: {
							type: `isDivingTypeCaveDiving`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Night diving",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeNightDiving`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeNightDiving`
						},
						createOptions: {
							type: `isDivingTypeNightDiving`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Technical diving",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDivingTypeTechnicalDiving`,
					props: {
						suggest: {
							typeIncludes: `isDivingTypeTechnicalDiving`
						},
						createOptions: {
							type: `isDivingTypeTechnicalDiving`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Provide details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0divingTypeDetails`,
					props: {
						suggest: {
							typeIncludes: `divingTypeDetails`
						},
						createOptions: {
							type: `divingTypeDetails`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaLocation() {
			return [
				{
					label: "Inland waters",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDiveLocationInlandWaters`,
					props: {
						suggest: {
							typeIncludes: `isDiveLocationInlandWaters`
						},
						createOptions: {
							type: `isDiveLocationInlandWaters`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Sea or Ocean",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDiveLocationSeaOrOcean`,
					props: {
						suggest: {
							typeIncludes: `isDiveLocationSeaOrOcean`
						},
						createOptions: {
							type: `isDiveLocationSeaOrOcean`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaLessThan50ft() {
			return [
				{
					label: "No. of Dives in last 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDivesLessThan50ftInLastYear`,
					props: {
						suggest: {
							typeIncludes: `numOfDivesLessThan50ftInLastYear`
						},
						createOptions: {
							type: `numOfDivesLessThan50ftInLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: "Average Time in last 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTimeLessThan50ftInLastYear`,
					props: {
						suggest: {
							typeIncludes: `averageTimeLessThan50ftInLastYear`
						},
						createOptions: {
							type: `averageTimeLessThan50ftInLastYear`,
							dataType: "string"
						}
					}
				},
				{
					label: "No. of Dives in next 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDivesLessThan50ftInNextYear`,
					props: {
						suggest: {
							typeIncludes: `numOfDivesLessThan50ftInNextYear`
						},
						createOptions: {
							type: `numOfDivesLessThan50ftInNextYear`,
							dataType: "number"
						}
					}
				},
				{
					label: "Average Time in next 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTimeLessThan50ftInNextYear`,
					props: {
						suggest: {
							typeIncludes: `averageTimeLessThan50ftInNextYear`
						},
						createOptions: {
							type: `averageTimeLessThan50ftInNextYear`,
							dataType: "string"
						}
					}
				}
			]
		},

		schema50to75ft() {
			return [
				{
					label: "No. of Dives in last 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDives50to75ftInLastYear`,
					props: {
						suggest: {
							typeIncludes: `numOfDives50to75ftInLastYear`
						},
						createOptions: {
							type: `numOfDives50to75ftInLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: "Average Time in last 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTime50to75ftInLastYear`,
					props: {
						suggest: {
							typeIncludes: `averageTime50to75ftInLastYear`
						},
						createOptions: {
							type: `averageTime50to75ftInLastYear`,
							dataType: "string"
						}
					}
				},
				{
					label: "No. of Dives in next 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDives50to75ftInNextYear`,
					props: {
						suggest: {
							typeIncludes: `numOfDives50to75ftInNextYear`
						},
						createOptions: {
							type: `numOfDives50to75ftInNextYear`,
							dataType: "number"
						}
					}
				},
				{
					label: "Average Time in next 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTime50to75ftInNextYear`,
					props: {
						suggest: {
							typeIncludes: `averageTime50to75ftInNextYear`
						},
						createOptions: {
							type: `averageTime50to75ftInNextYear`,
							dataType: "string"
						}
					}
				}
			]
		},

		schema76to100ft() {
			return [
				{
					label: "No. of Dives in last 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDives76to100ftInLastYear`,
					props: {
						suggest: {
							typeIncludes: `numOfDives76to100ftInLastYear`
						},
						createOptions: {
							type: `numOfDives76to100ftInLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: "Average Time in last 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTime76to100ftInLastYear`,
					props: {
						suggest: {
							typeIncludes: `averageTime76to100ftInLastYear`
						},
						createOptions: {
							type: `averageTime76to100ftInLastYear`,
							dataType: "string"
						}
					}
				},
				{
					label: "No. of Dives in next 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDives76to100ftInNextYear`,
					props: {
						suggest: {
							typeIncludes: `numOfDives76to100ftInNextYear`
						},
						createOptions: {
							type: `numOfDives76to100ftInNextYear`,
							dataType: "number"
						}
					}
				},
				{
					label: "Average Time in next 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTime76to100ftInNextYear`,
					props: {
						suggest: {
							typeIncludes: `averageTime76to100ftInNextYear`
						},
						createOptions: {
							type: `averageTime76to100ftInNextYear`,
							dataType: "string"
						}
					}
				}
			]
		},

		schema101to120ft() {
			return [
				{
					label: "No. of Dives in last 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDives101to120ftInLastYear`,
					props: {
						suggest: {
							typeIncludes: `numOfDives101to120ftInLastYear`
						},
						createOptions: {
							type: `numOfDives101to120ftInLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: "Average Time in last 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTime101to120ftInLastYear`,
					props: {
						suggest: {
							typeIncludes: `averageTime101to120ftInLastYear`
						},
						createOptions: {
							type: `averageTime101to120ftInLastYear`,
							dataType: "string"
						}
					}
				},
				{
					label: "No. of Dives in next 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDives101to120ftInNextYear`,
					props: {
						suggest: {
							typeIncludes: `numOfDives101to120ftInNextYear`
						},
						createOptions: {
							type: `numOfDives101to120ftInNextYear`,
							dataType: "number"
						}
					}
				},
				{
					label: "Average Time in next 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTime101to120ftInNextYear`,
					props: {
						suggest: {
							typeIncludes: `averageTime101to120ftInNextYear`
						},
						createOptions: {
							type: `averageTime101to120ftInNextYear`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaOver120ft() {
			return [
				{
					label: "No. of Dives in last 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDivesOver120ftInLastYear`,
					props: {
						suggest: {
							typeIncludes: `numOfDivesOver120ftInLastYear`
						},
						createOptions: {
							type: `numOfDivesOver120ftInLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: "Average Time in last 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTimeOver120ftInLastYear`,
					props: {
						suggest: {
							typeIncludes: `averageTimeOver120ftInLastYear`
						},
						createOptions: {
							type: `averageTimeOver120ftInLastYear`,
							dataType: "string"
						}
					}
				},
				{
					label: "No. of Dives in next 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0numOfDivesOver120ftInNextYear`,
					props: {
						suggest: {
							typeIncludes: `numOfDivesOver120ftInNextYear`
						},
						createOptions: {
							type: `numOfDivesOver120ftInNextYear`,
							dataType: "number"
						}
					}
				},
				{
					label: "Average Time in next 12 months",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0averageTimeOver120ftInNextYear`,
					props: {
						suggest: {
							typeIncludes: `averageTimeOver120ftInNextYear`
						},
						createOptions: {
							type: `averageTimeOver120ftInNextYear`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
